// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Pzsk","newExpiryDate":"styles_newExpiryDate__3Okiw","footer":"styles_footer__1wTNH"};